export const ConfigKey_FAQ_ParentOrder = 'faq__parent-order';
//# sourceMappingURL=app-config.js.map